import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=79a1b1c3&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=79a1b1c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1b1c3",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-bbs/pages/index/index.vue"
export default component.exports